// removed by extract-text-webpack-plugin
module.exports = {"submitBtn":"_3P5bktJtdLYJ0_-Tr8eGIP_0","wrapper":"_3UPLOuiysCnqJFVcGh50Le_0","form":"_1y6ySjBKRWjZdKscP3ibJ6_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-262d5991","scoped":false,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UserInfo/User.vue
// module id = oGEy
// module chunks = 1